import React, { ReactNode } from 'react'

import img1 from 'assets/images/distributionPage/whoPartners/1.png'
import img2 from 'assets/images/distributionPage/whoPartners/2.png'
import img3 from 'assets/images/distributionPage/whoPartners/3.png'
import img4 from 'assets/images/distributionPage/whoPartners/4.png'
import img5 from 'assets/images/distributionPage/whoPartners/5.png'
import bg from 'assets/images/distributionPage/whoPartners/bg.png'
import { Button } from 'shared/components'

import classes from './WhoPartner.module.scss'

const renderImage = (src: string) => (
  // <img className={classes.item__img} src={src} alt="" />
  <div
    className={classes.item__img}
    style={{ backgroundImage: `url(${src}), url(${bg})` }}
  />
)

type Props = {
  src: ReactNode
  title: ReactNode
}

export const getItems = (
  setPartnerFormOpened: (open: boolean) => void
): Props[] => [
  {
    src: renderImage(img1),
    title:
      'Розничные сети,\nинтернет-магазины розничных товаров и услуг, Банки',
  },
  {
    src: renderImage(img2),
    title: 'Развлекательные\nи образовательные\nорганизации, досуговые\nцентры',
  },
  {
    src: renderImage(img3),
    title:
      'Агрегаторы такси,\nбилетов, отелей, скидок\nи других сфер деятельности',
  },
  {
    src: renderImage(img4),
    title: 'Службы доставки товаров, оказания услуг, агентские сети, пиццерии',
  },
  {
    src: renderImage(img5),
    title: 'Операторы фиксированной связи, виртуальные операторы, колл-центры',
  },
  {
    src: (
      <div className={classes.item__plus}>
        <i className={`icon-plus-2 ${classes['item__plus--icon']}`} />
      </div>
    ),
    title: (
      <>
        <span className={classes['item__plus--title']}>
          Всегда открыты для сотрудничества с прочими видами бизнеса
        </span>
        <Button size="small" onClick={() => setPartnerFormOpened(true)}>
          Стать партнером
        </Button>
      </>
    ),
  },
]
